import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import AlertaInline from '../../Miscelania/AlertaInline';
import InputMask from 'react-input-mask';
import RequestApi from '../../Miscelania/RequestApi';

const PropTypes = require('prop-types');

class ExamButtonOpen extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      modal: false,
      exam_finish: this.props.dadosProva.exam_finish_str,
      exam_start: this.props.dadosProva.exam_start_str,
      status_str: this.props.dadosProva.status_str,
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.showModal = this.showModal.bind(this);
    this.confirmarProva = this.confirmarProva.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  confirmarProva(event) {
    event.preventDefault();
    var dados_salvar = {
      exam_start: this.state.exam_start,
      exam_finish: this.state.exam_finish,
      id: this.props.dadosProva.id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/instrutor/confirmar_prova', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_alerta: 1});
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
        self.props.recarregarProvas();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showModal(event) {
    this.setState({ modal: true });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  {
    (self.state.status_str === 'Indisponível') ?
      <button title="Prova expirada. Confirmar nova data" alt="Prova expirada. Confirmar nova data" onClick={this.showModal} className='btn btn-xs btn-primary'><i className="fa fa-fw fa-warning"></i></button>
    : 
      <button title="Lançar prova" alt="Lançar prova" onClick={this.showModal} className='btn btn-xs btn-primary'><i className="fa fa-fw fa-check"></i></button>
  }

  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Prova aberta</b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      {(this.state.status_alerta == 1) ? <div><AlertaInline mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /><br/></div> : ""} 
      <form onSubmit={this.confirmarProva}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Horário inicial:</label>
              <InputMask value={this.state.exam_start}  maskChar={null} name="exam_start" mask="99/99/9999 99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'exam_start')} placeholder="Início da prova"/>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Horário final:</label>
              <InputMask value={this.state.exam_finish}  maskChar={null} name="exam_finish" mask="99/99/9999 99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'exam_finish')} placeholder="Final da prova"/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Lançar prova</button>
          </div>
        </div>
      </form>
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

ExamButtonOpen.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamButtonOpen;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamButtonOpen.js